/**
 * 询价模块 by 购物车询价
 */

// import axios from 'axios';
import fetchJsonp from 'fetch-jsonp';
import { Base64 } from 'js-base64';
import kvstore from '../product/kvstore';
function getAnonymityPrice(config, resolve) {
  fetchPrice(config, resolve, true);
}
//获取商品价格
function getPrice(config, hasSetValue, resolve) {
  if (window.$ACE && window.$ACE.Account) {
    window.$ACE.Account.isLogin().then(isLogin => {
      // 已经登录
      if (isLogin) {
        fetchPrice(config, resolve);
      } else if (hasSetValue) {
        // 修改过选项，走匿名询价
        getAnonymityPrice(config, resolve);
      } else {
        resolve();
      }
    });
  } else if (hasSetValue) {
    // 兜底逻辑，在ACE未加载时，应该不会命中，若命中，统一走匿名询价
    getAnonymityPrice(config, resolve);
  } else {
    resolve();
  }
}

function fetchPrice(config, resolve, isUserInnerAccount) {
  let params = JSON.stringify({
    items: [config]
  });
  if (config.commodityCode == 'prepaid_kvstore') {
    params = kvstore(config);
  }

  let url = '//cart.aliyun.com/buy/describePrice.jsonp?';
  if (config.commodityCode !== 'vm' || config.commodityCode !== 'rds') {
    url += 'commodityCode=' + config.commodityCode;
  }
  return fetchJsonp(url + '&param=' + Base64.encode(params) +
    '&isUserInnerAccount=' + (isUserInnerAccount ? 'true' : 'false'))
    .then((response) => response.json())
    .then((res) => {
      let price;

      if (res && res.code == '200') {
        price = res.data.items[0];
      }
      
      resolve(price.errorMessage ? null : price);

    }).catch(function () {
      resolve();
    });
}

export { getPrice, getAnonymityPrice };


// WEBPACK FOOTER //
// ./lib/services/services/price.js